import Snap from 'snapsvg-cjs';
import createTriangle from './create-triangle';

const buttons = () => {
  let i = 0;
  document.querySelectorAll('.c-button--alternative').forEach(element => {
    const s = Snap(40, 35);
    s.attr({
      class: 'c-button__triangle',
    });
    createTriangle(s, 20, 0, 10, 6.5, 8, false);
    element.appendChild(document.querySelectorAll('.c-button__triangle')[i]);
    i++;
  });
};

export default buttons;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/kerris-select-chisel/src/scripts/modules/buttons.js